import { Component, OnInit } from '@angular/core';
import { LoginService } from '@serengeti/serengeti-common';
import { MonitoringApplicationService } from '@serengeti/serengeti-resource';

@Component({
  selector: 'app-wizard-monitoring-dialog',
  templateUrl: './monitoring-dialog.component.html',
  styleUrls: ['./monitoring-dialog.component.scss']
})
export class WizardMonitoringDialogComponent implements OnInit {

  applications: any[] = [];
  items: any[] = [];
  item: any;

  standardMonitoringSet;
  
  selectedMonitoringItemsId: any[] = [];

  checkLimit: boolean = false;
  checkLimitCount: number = 0;

  constructor(
    private monitoringService: MonitoringApplicationService,
    private loginService: LoginService
  ) { }

  ngOnInit() {
    this.getPersonalMonitoringSet();
  }
  
  public getPersonalMonitoringSet() {
    this.monitoringService.getPersonalMonitoringSet().subscribe(res => {
      if (res.body) {
        const monitorSet = JSON.parse(res.body.monitoringSet);
        this.getMonitoringItems(monitorSet);
      }
    })
  }

  getMonitoringItems(monitorSet) {
    const keys = Object.keys(monitorSet);
    for (let i=0; i<keys.length; i++) {
      const key = keys[i];
      this.items.push(monitorSet[key]);
    }

    let maxIndex = -1;
    let maxSize = -1;

    this.items.forEach((item, index) => {
      if (item.items && item.items.length > maxSize) {
        maxSize = item.items.length;
        maxIndex = index;
      }
    });
    this.standardMonitoringSet = this.items[maxIndex].items;

    this.getApplicationItem(this.standardMonitoringSet[0].hostid);
  }

  getApplicationItem(hostId) {
    this.monitoringService.list(hostId).subscribe(res => {
      this.applications = res;
    });
  }

  selectedMonitoringItem(event, item) {
    if (event.checked) {
      this.checkLimitCount++;

      this.selectedMonitoringItemsId.push(item.templateid);
    } else {
      this.checkLimitCount--;

      const selectedMonitoringItemsFilter = this.selectedMonitoringItemsId.filter((element) => element !== item.templateid);
      this.selectedMonitoringItemsId = selectedMonitoringItemsFilter;
    }

    if (this.checkLimitCount === 2) {
      this.checkLimit = true;
    } else {
      this.checkLimit = false;
    }
  }
  
}
